import { Controller, useFormContext } from 'react-hook-form';
import { Box, TextField } from '@mui/material';
import Text from '../Text/Text';
import ToolTip from '../ToolTip/ToolTip';

// A config int that must be 0 or more, matching the backend's own
// `_non_negative_int` check - truncates as the user types so an invalid
// value (negative, fractional) is never something they can save.
const clampNonNegativeInt = (rawValue: string): number | undefined => {
  if (rawValue === '') return undefined;
  const parsed = Number(rawValue);
  if (Number.isNaN(parsed)) return undefined;
  return Math.max(0, Math.trunc(parsed));
};

interface WebscrapNumberFieldProps {
  name: string;
  label: string;
  tooltip?: string;
}

const WebscrapNumberField = ({
  name,
  label,
  tooltip,
}: WebscrapNumberFieldProps) => {
  const { control } = useFormContext();

  return (
    <Box>
      <Text type="label">
        {tooltip ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
            {label}
            <ToolTip title={tooltip} />
          </Box>
        ) : (
          label
        )}
      </Text>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <TextField
            type="number"
            fullWidth
            size="small"
            value={field.value ?? ''}
            onChange={event =>
              field.onChange(clampNonNegativeInt(event.target.value))
            }
            onBlur={field.onBlur}
            inputProps={{ min: 0, step: 1, 'aria-label': label }}
          />
        )}
      />
    </Box>
  );
};

export default WebscrapNumberField;
